<script>
	export default {
		name: 'ContentExecuter',
		methods: {
			getContentsSubset(contents, key, val) {
				const self_ = this;

				if(self_.isFalse(contents) || self_.isFalse(key)) { return null }

				if(key == 'startDate') { 
					return self_.$_cntExec_getByStartDate(contents, val) 
				}
				else if(key == 'endDate') { 
					return self_.$_cntExec_getByEndDate(contents, val) 
				}
				else if(key == 'searchText') { 
					return self_.$_cntExec_getBySearchText(contents, val) 
				}
				else if(key == 'securityGroup') { 
					return self_.$_cntExec_getBySecurityGroup(contents, val) 
				}
				else {
					return self_.filterObject(contents, key, val)
				}
			},
			$_cntExec_getByStartDate(contents, dateVal) {
				const self_ = this;
				
				if(self_.isFalse(contents) || self_.isFalse(dateVal)) { return null }

				const array_ = self_.arrayObject(contents)

				const subset_ = array_.filter(item => item.startDate >= dateVal)

				if(self_.isEmpty(subset_)) { return null }
				else { return self_.objectArray(subset_) }
			},
			$_cntExec_getByEndDate(contents, dateVal) {
				const self_ = this;

				if(self_.isFalse(contents) || self_.isFalse(dateVal)) { return null }
				
				const array_ = self_.arrayObject(contents)

				const subset_ = array_.filter(item => item.endDate <= dateVal)

				if(self_.isEmpty(subset_)) { return null }
				else { return self_.objectArray(subset_) }
			},
			$_cntExec_getBySearchText(contents, textVal) {
				const self_ = this;

				if(self_.isFalse(contents) || self_.isFalse(textVal)) { return null }

				const array_ = self_.arrayObject(contents)

				const subset_ = array_.filter(item => item.text.indexOf(textVal) != -1)

				if(self_.isEmpty(subset_)) { return null }
				else { return self_.objectArray(subset_) }
			},
			$_cntExec_getBySecurityGroup(contents, groupVal) {
				const self_ = this;

				if(self_.isFalse(contents) || self_.isFalse(groupVal)) { return null }

				const array_ = self_.arrayObject(contents)

				const subset_ = array_.filter(item => {
					if(self_.isFalse(item.securityGroup)) { return false }
					return	self_.checkSecurityGroup(item.securityGroup)
				})

				if(self_.isEmpty(subset_)) { return null }
				else { return self_.objectArray(subset_) }
			}
		}
	}
</script>